import { getEnvironments } from '@/api/environments';
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/')({
  component: RouteComponent,
  loader: async () => {
    const res = await getEnvironments();
    return res;
  },
  errorComponent: () => <div>An error occurred</div>,
});

function RouteComponent() {
  const res = Route.useLoaderData();

  if (res?.status !== 200) return <div>An error occurred, {res.data.errorMessage}</div>;

  return <Navigate to={`/$env/scheduler`} params={{ env: res.data.environments[0].name }} />;
}
